import { render, staticRenderFns } from "./FilerAdministration.vue?vue&type=template&id=53d98920&"
import script from "./FilerAdministration.vue?vue&type=script&lang=js&"
export * from "./FilerAdministration.vue?vue&type=script&lang=js&"
import style0 from "./FilerAdministration.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports